import { Link } from 'react-router'
import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useUsageSummary } from '../../api/usage'
import { SpinLoader } from '../shared/SpinLoader'

// Voysi flamingo spend banner. Visual reference: screens-1.jsx::DashboardScreen
// (the gradient FFF1F6 → FFD8E5 card with the flamingo progress bar).
export function SpendSummaryCard() {
  const { t } = useTranslation('billing')
  const { data, isLoading } = useUsageSummary()

  if (isLoading || !data) {
    return (
      <div className="rounded-2xl border border-flamingo-100 bg-flamingo-50 p-5">
        <SpinLoader size="sm" />
      </div>
    )
  }

  const used = data.period.monthly_used_usd
  const cap = data.period.monthly_cap_usd
  const pct = cap > 0 ? Math.min((used / cap) * 100, 100) : 0
  const dailyUsed = data.period.daily_used_usd
  const dailyCap = data.period.daily_cap_usd

  return (
    <div
      className="relative flex flex-col gap-2 overflow-hidden rounded-2xl border p-[18px]"
      style={{
        background: 'linear-gradient(135deg,#FFF1F6 0%, #FFD8E5 100%)',
        borderColor: '#FFD8E5',
      }}
    >
      <div className="flex items-center justify-between">
        <div className="text-[11px] font-bold uppercase tracking-[0.06em] text-flamingo-800">
          {t('spendSummary.title')}
        </div>
        <Link
          to="/app/usage"
          className="flex items-center gap-1 text-xs font-semibold text-flamingo-700 hover:underline"
        >
          {t('spendSummary.viewDetails')} <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
      <div className="flex items-baseline gap-2.5">
        <div className="font-display text-[36px] font-extrabold leading-none tracking-tight text-ink-900">
          ${used.toFixed(2)}
        </div>
        <div className="text-[13px] text-ink-500">of ${cap.toFixed(2)} cap</div>
      </div>
      <div
        className="mt-1 h-2 overflow-hidden rounded-full"
        style={{ background: 'rgba(255,255,255,0.55)' }}
      >
        <div
          className="h-full"
          style={{
            width: `${pct}%`,
            background: 'linear-gradient(90deg,#FF3D84,#FF7FAC)',
          }}
        />
      </div>
      <div className="mt-1 flex justify-between text-[11px] text-ink-500">
        <span>
          ${dailyUsed.toFixed(2)} today (cap ${dailyCap.toFixed(2)})
        </span>
        <span>{Math.round(pct)}% used</span>
      </div>
    </div>
  )
}
